import { render, staticRenderFns } from "./AccidentalMedical.vue?vue&type=template&id=2dd7964d"
import script from "./AccidentalMedical.vue?vue&type=script&lang=js"
export * from "./AccidentalMedical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports